/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmSpeechDeleteTtsHistory } from "../../funcs/llmSpeechDeleteTtsHistory.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.DeleteTextToSpeechHistoryRequest$inboundSchema,
};

export const tool$llmSpeechDeleteTtsHistory: ToolDefinition<typeof args> = {
  name: "llm-speech-delete-tts-history",
  description: `Delete text-to-speech history item

Deletes a stored text-to-speech generation. The audio blob is content-addressed and may be shared, so it is left in storage.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmSpeechDeleteTtsHistory(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
